import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Calendar, Clock, Users } from "lucide-react";

export default function ManageShifts() {
  const [shifts, setShifts] = useState([]);
  const load = async () => {
    const { data } = await api.get("/shifts", { params: { mine: true } });
    setShifts(data);
  };
  useEffect(() => { load(); }, []);

  const groups = {
    open: shifts.filter((s) => s.status === "open"),
    accepted: shifts.filter((s) => s.status === "accepted"),
    cancelled: shifts.filter((s) => s.status === "cancelled"),
  };

  return (
    <div className="space-y-6" data-testid="manage-shifts-page">
      <div>
        <div className="overline text-trital-red">Operations</div>
        <h1 className="mt-1 font-display font-black text-3xl lg:text-4xl text-slate-900 tracking-tight">Manage Shifts</h1>
        <p className="text-slate-600 text-sm">Track your posted shifts and their fill status.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-4">
        {[{ k: "open", Icon: Calendar, c: "bg-trital-medical-blue-soft text-trital-navy" }, { k: "accepted", Icon: Users, c: "bg-emerald-50 text-emerald-700" }, { k: "cancelled", Icon: Clock, c: "bg-red-50 text-trital-red" }].map(({ k, Icon, c }) => (
          <div key={k} className="rounded-2xl bg-white border border-slate-200 p-5 shadow-card">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${c}`}><Icon className="w-5 h-5" /></div>
            <div className="mt-3 font-display font-black text-3xl text-slate-900">{groups[k].length}</div>
            <div className="overline text-slate-500">{k}</div>
          </div>
        ))}
      </div>
      <div className="space-y-3">
        {shifts.length === 0 && <div className="text-slate-500 bg-white border border-slate-200 rounded-xl p-6">You haven't posted any shifts yet.</div>}
        {shifts.map((s) => (
          <div key={s.id} className="rounded-2xl bg-white border border-slate-200 p-5 shadow-card flex items-center justify-between">
            <div>
              <div className="font-display font-bold text-slate-900">{s.title}</div>
              <div className="text-xs text-slate-500 mt-1">{s.city}, {s.state} • {new Date(s.start_time).toLocaleString()}</div>
              <div className="mt-2 flex gap-2">
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-bold uppercase tracking-wider">{s.specialty}</span>
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-700 font-bold uppercase tracking-wider">{s.shift_type}</span>
              </div>
            </div>
            <div className="text-right">
              <div className="font-display font-black text-trital-navy text-xl">${s.hourly_rate}/hr</div>
              <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-bold ${s.status === "accepted" ? "bg-emerald-50 text-emerald-700" : s.status === "cancelled" ? "bg-red-50 text-trital-red" : "bg-amber-50 text-amber-700"}`}>{s.status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
